module.exports = __webpack_public_path__ + "static/media/signal-alt-slash.78855a96.svg";